import { Controller } from '@hotwired/stimulus';

export class PaymentMethodController extends Controller {
  static targets = [
    'input',
  ];

  submit(event) {
    event.preventDefault();

    if (this.inputTargets.length === 1 && this.inputTarget.value === 'new_credit_card') {
      this.dispatch('tokenize');
      return;
    }

    for (const target of this.inputTargets) {
      if (target.checked && target.value === 'new_credit_card') {
        this.dispatch('tokenize');
        return;
      }
    }

    this.element.submit();
  }
}
